import React from "react";

import GlobalFunctionHelper from '../../Utilities/Helpers/GlobalFunctionHelper';

import { ViewType } from '../../Utilities/Enums/ViewTypeEnum';
import { AdminUserField, AdminUserListField, AdminUserAddressField, AdminUserProfileField, ImageFileField, TwoWayFactorDataField } from '../../Utilities/Enums/ParametersEnum';
import { ActiveStatusEnum } from '../../Utilities/Enums/StatusEnums';
import { CurrencyEnum } from '../../Utilities/Enums/CurrencyEnums';

import { Role } from '../Maintenance/Accessibilities/Roles';

export class AdminUserControl {
    [AdminUserField.ADDRESS]?: AdminUserAddress = new AdminUserAddress();
    [AdminUserField.PASSWORD]?: string = "";
    [AdminUserField.CONFIRM_PASSWORD]?: string = "";
    [AdminUserField.PROFILE]?: AdminUserProfile = new AdminUserProfile();
    [AdminUserField.PUBLIC_ID]?: string | number = "";
    [AdminUserField.ROLE]?: Role = new Role();
    [AdminUserField.ROLE_PUBLIC_ID]?: string | number | null = null;
    [AdminUserField.STATUS]?: ActiveStatusEnum = ActiveStatusEnum.ACTIVE;
    [AdminUserField.USERNAME]?: string = "";
    [AdminUserField.USER_EMAIL]?: string = "";
    [AdminUserField.USER_CONTACT_NUMBER]?: string = "";

    [AdminUserField.ENABLE_2FA]?: boolean = false;

    [AdminUserField.CREATED_DATE]?: string | Date | null = null;
    [AdminUserField.UPDATED_DATE]?: string | Date | null = null;

    [ImageFileField.IMAGE_FILE]?: any | null = null;
    [ImageFileField.VIEW_IMAGE]?: any | null = null;
    
    constructor(obj?: Partial<AdminUserControl>) {
        Object.assign(this, obj);
    }
}

export class AdminUserList {
    [AdminUserListField.PUBLIC_ID]?: string | number = "";
    [AdminUserListField.NAME]?: string = "";
    [AdminUserListField.ROLE_NAME]?: string = "";
    [AdminUserListField.ROLE_PUBLIC_ID]?: string | number | null = null;
    [AdminUserListField.STATUS]: number = 0;
    [AdminUserListField.UPDATED_DATE]?: string | Date | null = null;
    [AdminUserListField.CREATED_DATE]?: string | Date | null = null;
    [AdminUserListField.USERNAME]?: string = "";

    constructor(obj?: Partial<AdminUserList>) {
        Object.assign(this, obj);
    }
}

export class AdminUserAddress {
    [AdminUserAddressField.ADDRESS_TYPE]: number = 0;
    [AdminUserAddressField.CITY]: string = "";
    [AdminUserAddressField.COUNTRY]: string = "";
    [AdminUserAddressField.FULL_ADDRESS]: string = "";
    [AdminUserAddressField.STATE]: string = "";
    [AdminUserAddressField.STREET_ADDRESS]: string = "";
    [AdminUserAddressField.ZIP_CODE]: string = "";

    constructor(obj?: Partial<AdminUserAddress>) {
        Object.assign(this, obj);
    }
}

export class AdminUserProfile {
    [AdminUserProfileField.NAME]: string = "";
    [AdminUserProfileField.FIRST_NAME]: string = "";
    [AdminUserProfileField.LAST_NAME]: string = "";
    [AdminUserProfileField.EMAIL]: string = "";
    [AdminUserProfileField.CONTACT_NUMBER]: string = "";
    [AdminUserProfileField.COMPANY_PUBLIC_ID]: string | number | null = null;
    [AdminUserProfileField.REGISTERED_COMPANY]: string = '';
    [AdminUserProfileField.TAX_NO]: string = "";

    [AdminUserProfileField.CURRENCY_CODE]?: CurrencyEnum = GlobalFunctionHelper.getCurrencyCode() ?? CurrencyEnum.PHP;

    [AdminUserProfileField.VENDORS]?: any = [];
    [AdminUserProfileField.VENDOR_IDS]?: any = [];

    constructor(obj?: Partial<AdminUserProfile>) {
        Object.assign(this, obj);
    }
}

export class AdminUserDetailsInterface {
    adminuserid?: string | number;
    viewType?: ViewType;
    setviewType?: React.Dispatch<React.SetStateAction<ViewType>>;
    setopenDelete?: React.Dispatch<React.SetStateAction<boolean>>;
    settoDeleteItem?: React.Dispatch<React.SetStateAction<any>>;
    previewData?: AdminUserControl;
    formData?: AdminUserControl;
    setformData?: React.Dispatch<React.SetStateAction<AdminUserControl>>;
    errorMessages?: any;
    setErrorMessages?: React.Dispatch<React.SetStateAction<any>>;
    DropdownData?: any;
    dropdownFetchStatus?: boolean;
    handleSubmit?: () => void = () =>{};
    handleResetPassword?: () => void = () =>{};
    resetPassword?: boolean;
    setresetPassword?: React.Dispatch<React.SetStateAction<boolean>>;
    routePath?: any;
    setopenQRCodeModal?: React.Dispatch<React.SetStateAction<boolean>>;
    openQRCodeModal?: boolean;
}

export class TwoWayFactorData {
    [TwoWayFactorDataField.OTP_AUTH_URL]: string = "";
    [TwoWayFactorDataField.SECRET_KEY]: string = "";

    constructor(obj?: Partial<TwoWayFactorData>) {
        Object.assign(this, obj);
    }
}

export class QRCodeModalInterface {
    openModal?: boolean;
    setopenModal?: React.Dispatch<React.SetStateAction<boolean>>;
    formData?: AdminUserControl;
    getAdminUserData?: () => void = () =>{};

    constructor(obj?: Partial<QRCodeModalInterface>) {
        Object.assign(this, obj);
    }
}